import camelCase from 'lodash/camelCase';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ProfileButton from '../../../assets/images/directory/profile_button.svg';

import { subscriber_profile_path } from '../../routes.js';
import { DirectorySubscriber } from '../../utils/backend-api/subscriber_directory';
import NoResultsMessage from '../shared/NoResultsMessage';

interface ProfileListProps {
  currentUserId: number;
  descriptionField?: string;
  navigate: (path: string) => void;
  onSearchPage?: boolean;
  profiles: DirectorySubscriber[];
  setMessageUser?: (profile: DirectorySubscriber) => void;
}

const ProfilesList = ({
  currentUserId,
  descriptionField,
  navigate,
  onSearchPage = false,
  profiles,
  setMessageUser,
}: ProfileListProps) => {
  if (profiles.length <= 0) {
    return <NoResultsMessage className={!onSearchPage && 'profile-no-results'} />;
  } else {
    return (
      <>
        {profiles.map((profile) => (
          <Row className="profile-container" key={profile.id} data-test="profile">
            <Col
              className="col-md-8 profile-info-wrapper"
              onClick={(e) => {
                e.preventDefault;
                navigate(subscriber_profile_path(profile.username));
              }}
            >
              <div className="avatar-container">
                {profile.picture ? (
                  <img src={profile.picture} />
                ) : (
                  <div className="avatar-placeholder">
                    <div className="avatar-name">{profile.subInitial}</div>
                  </div>
                )}
              </div>

              <div className="profile-details">
                <div className="name">{profile.name}</div>
                <div className="profile-detail">{profile.oneLineBio}</div>
                <div className="profile-detail">
                  <div className="title-company-wrapper">
                    {profile.titleAtCompany}
                    {profile.titleAtCompany && profile.companyName && (
                      <div className="dot-middle">.</div>
                    )}
                    {profile.companyName}
                  </div>
                </div>
                {descriptionField && profile[camelCase(`${descriptionField}_desc`)] && (
                  <div className="profile-detail">
                    {profile[camelCase(`${descriptionField}_desc`)]}
                  </div>
                )}

                <div className="mobile-view-profile">
                  <div className="action-container">
                    {profile.canSendMessage && profile.id !== currentUserId && !onSearchPage && (
                      <button className="send-message-btn" onClick={() => setMessageUser(profile)}>
                        Message
                        <img src={ProfileButton} />
                      </button>
                    )}
                    <div>
                      <a href={subscriber_profile_path(profile.username)}>View Profile</a>
                      <img src={ProfileButton} />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-md-4 view-profile">
              <div className="action-container">
                {profile.canSendMessage && profile.id !== currentUserId && !onSearchPage && (
                  <button className="send-message-btn" onClick={() => setMessageUser(profile)}>
                    Message
                    <img src={ProfileButton} />
                  </button>
                )}
                <div>
                  <a href={subscriber_profile_path(profile.username)}>View Profile</a>
                  <img src={ProfileButton} />
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </>
    );
  }
};

export default ProfilesList;
